define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/heading/AggregateController"
], function(declare,lang,AggregateController) {

	return declare(AggregateController, {
		getFormData: function() {
			var fd = this.inherited(arguments);
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregateElement);
			return fd;
		},

		_canAggregateElement: function(/*Context*/ctx, /*FormData*/fd) {
			var elem = this.getNode();
			var pred = ctx.getNode();

			if (pred.$URL == elem.$URL)
				return false;

			if (this._isDescendant(ctx, elem, pred))
				return false;

			if (this._isDescendant(ctx, pred, elem))
				return false;

			return true;
		},

	    _isDescendant: function(ctx, parent, elem) {
	        if (elem.__Parent__ == elem.WBS)
	            return false;

	        if (elem.__Parent__ == parent.$URL)
	            return true;

	        return this._isDescendant(ctx, parent, ctx.cache.getNode(elem.__Parent__, true));
	    }
 	});
});